import './banner.scss'

$(() => {
  $(".promo_banner_close_button").on("click", () => $(".promo-banner-component").addClass('hidden invisible'));
});


// WEBPACK FOOTER //
// ./app/components/promotional/banner.js